



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Gdpr from '@/model';
import Chapter from '@/components/Chapter.vue'; // @ is an alias to /src

@Component({
  components: {
    Chapter,
  },
})
export default class Regulation extends Vue {
  @Prop({ default: 'en' }) private lang!: string;
  @Prop({ default: 0 }) private article!: number;
  @Prop({ default: 0 }) private chapter!: number;
  @Prop({ default: true }) private interactive!: boolean;

  private chapters: Gdpr.Chapter[] = [];
  private articles: Gdpr.Article[] = [];
  private loading: boolean = false;
  private language: string = '';
  private error: string | null = null;

  @Watch('lang')
  private onLangChanged(val: string, oldVal: string): void {
    this.reload();
  }

  @Watch('article')
  private onArticleChanged(val: number, oldVal: number): void {
    this.reload();
  }

  @Watch('chapter')
  private onChapterChanged(val: number, oldVal: number): void {
    this.reload();
  }

  @Watch('interactive')
  private onInteractiveChanged(val: boolean, oldVal: boolean): void {
    this.reload();
  }

  private onArticleClick(article: Gdpr.Article) {
    if (!this.interactive) { return; }
    if (article.display) {
      this.$router.push({
        name: 'browse',
        query: { lang: this.lang, chapter: '' + article.address.chapter },
      });
    } else {
      this.$router.push({
        name: 'browse',
        query: { lang: this.lang, article: '' + article.address.article },
      });
    }
  }

  private onChapterClick(chapter: Gdpr.Chapter) {
    if (!this.interactive) { return; }
    if (chapter.display) {
      this.$router.push({ name: 'browse', query: { lang: this.lang } });
    } else {
      this.$router.push({
        name: 'browse',
        query: { lang: this.lang, chapter: '' + chapter.address.chapter },
      });
    }
  }

  private reload(): void {
    if (this.lang === this.language) {
      this.updateView();
    } else {
      this.loading = true;
      const lang = this.lang;
      this.error = null;
      const source = this.$root.$props.source;
      this.$http.get(source + lang + '.json').then(
        (response) => {
          if (lang === this.lang) {
            this.loading = false;
            const chapters = response.data as Gdpr.Chapter[];
            const articles: Gdpr.Article[] = [];
            let articleCount = 0;
            chapters.forEach((chapter, chapterIndex) => {
              chapter.sec.forEach((section, sectionIndex) => {
                section.art.forEach((article, articleIndex) => {
                  articleCount += 1;
                  article.address = {
                    chapter: chapterIndex + 1,
                    article: articleCount,
                  };
                  article.display = false;
                  articles.push(article);
                });
              });
              chapter.art.forEach((article, articleIndex) => {
                articleCount += 1;
                article.address = {
                  chapter: chapterIndex + 1,
                  article: articleCount,
                };
                article.display = false;
                articles.push(article);
              });
              chapter.display = false;
              chapter.address = { chapter: chapterIndex + 1 };
            });
            this.chapters = chapters;
            this.articles = articles;
            this.language = lang;
            this.updateView();
          }
        },
        (error) => {
          if (lang === this.lang) {
            this.language = lang;
            this.error = 'Failed to load ' + lang + '.json';
          }
        });
    }
  }

  private updateView(): void {
    for (const chapter of this.chapters) {
      chapter.display = !this.interactive;
    }
    for (const article of this.articles) {
      article.display = !this.interactive;
    }
    if (this.interactive) {
      if (this.article > 0 && this.article <= this.articles.length) {
        this.articles[this.article - 1].display = true;
        this.chapters[
          this.articles[this.article - 1].address.chapter - 1
        ].display = true;
      } else if (this.chapter > 0 && this.chapter <= this.chapters.length) {
        this.chapters[this.chapter - 1].display = true;
      }
    }
    Vue.nextTick().then(() => this.scrollToSelection());
  }

  private mounted(): void {
    this.reload();
  }

  private scrollToSelection(): void {
    let element: HTMLElement | null = null;
    if (this.article > 0 && this.article <= this.articles.length) {
      element = document.getElementById('article-' + this.article);
    } else if (this.chapter > 0 && this.chapter <= this.chapters.length) {
      element = document.getElementById('chapter-' + this.chapter);
    }
    if (element != null) {
      element.scrollIntoView();
    }
  }
}
